






import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({ name: "ui-table-footer-item" })
export default class UiTableFooterItemComponent extends Vue {
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-table/src/ui-table-footer-item.vue